import { SET_QUESTION } from "./actionTypes";

export const setQuestion = value => {
  return dispatch => {
    dispatch({ type: SET_QUESTION, payload: value });
  };
};
